// extracted by mini-css-extract-plugin
export default {"buttonBase":"Button_buttonBase__Y189c","buttonLight":"Button_buttonLight__SNk0m","buttonDark":"Button_buttonDark__HBAvv"};